// extracted by mini-css-extract-plugin
export var wordContainer = "_r5-0";